export default {
  // home

  // ui
  entrar: "Enter",
  play: "Play",
  pause: "Pause",
  subtitles: "Subtitles",
  pantalla_completa: "Full screen",
  salir_pantalla_completa: "Exit full screen",
  escena_completada: "Scene completed",

  // overlays

  r1_1: "A) Save whatever money is left at the end of the month, as you've been doing until now.",
  r1_2: "B) Follow the Dubai lad's method: no planning, no changes to your habits and spectacular results.",
  r1_3: "C) Make regular contributions: set aside a fixed amount at the beginning of each month to invest, before you start spending.",

  r2_1: "A) The same as back then, because money kept at home remains untouched and retains its value.",
  r2_2: "B) Less than back then, because prices have been rising year after year. It has lost purchasing power.",
  r2_3: "C) More than back then, because money that has been stored away for so long increases in value on its own.",

  r3_1: "A) Because your life circumstances have changed: you've got married, had children, bought a house...",
  r3_2: "B) Because life insurance policies automatically expire after a certain period and need to be signed again.",
  r3_3: "C) Because the longer you stay with the same policy, the cheaper your insurer makes it.",

};